import { studentBookingClient } from '../client';

import { CreateBookingNoAdvanceFeeEndpoint } from './constants';
import { CreateBookingNoAdvanceFeeDto } from './dto/CreateBookingNoAdvanceFee.dto';

export const postCreateBookingNoAdvanceFee = async (
    verifyBookingData: CreateBookingNoAdvanceFeeDto
): Promise<string> => {
    const { data: response } = await studentBookingClient.post(
        CreateBookingNoAdvanceFeeEndpoint.CREATE,
        {
            basket_id: verifyBookingData.basket_id,
        }
    );

    return response.data;
};
